import { ModalForm } from './modal-form';
import { ModalHeader } from './modal-header';
import { useEffect } from 'react';

export const Modal = () => {
  useEffect(() => {
    document.body.classList.add('modal-open');
    return () => {
      document.body.classList.remove('modal-open');
    };
  }, []);

  return (
    <>
      <div className="modal fade show d-block" id="kt_modal" role="dialog" tabIndex={-1} aria-modal="true">
        {/* begin::Modal dialog */}
        <div className="modal-dialog modal-dialog-centered modal-xl">
          {/* begin::Modal content */}
          <div className="modal-content" style={{ height: 'calc(100vh - 200px)' }}>
            <ModalHeader />
            {/* begin::Modal body */}
            <div className="modal-body pb-4 pt-0">
              <ModalForm />
            </div>
            {/* end::Modal body */}
          </div>
          {/* end::Modal content */}
        </div>
        {/* end::Modal dialog */}
      </div>
      {/* begin::Modal Backdrop */}
      <div className="modal-backdrop fade show"></div>
      {/* end::Modal Backdrop */}
    </>
  );
};
